import axios from 'axios';
import { buildRequests } from '../util/buildRequest';
import { DOMAIN } from '../util/constants';
import { SetAuthHeader } from '../util/SetAuthHeader';
import { SetLanguageHeader } from '../util/SetLanguageHeader';
import { SetResponseInterceptor } from '../util/SetResponseInterceptor';

const API = `${DOMAIN}/api/v1/service-mgmt`;
const instance = axios.create({
  baseURL: API,
});

instance.interceptors.request.use(SetAuthHeader);
instance.interceptors.request.use(SetLanguageHeader);
SetResponseInterceptor(instance);

const requests = buildRequests(instance);

const publicServiceProviderInstance = axios.create({
  baseURL: API,
});

// Attach Accept-Language so the backend LocaleInterceptor can translate
// dynamic data even for unauthenticated (public) endpoints.
publicServiceProviderInstance.interceptors.request.use(SetLanguageHeader);
SetResponseInterceptor(publicServiceProviderInstance);

const publicServiceProviderRequests = buildRequests(publicServiceProviderInstance);

export { API as SERVICE_PROVIDER_API, requests as service_provider_api_requests, publicServiceProviderRequests as public_service_provider_api_requests };
